import React from 'react';
import {useDispatch} from 'react-redux';
import { StyleSheet, ScrollView, Text } from 'react-native';
import Market from './market';
import {Market as MarketModel} from '../models/market';

export default function MarketList() {
    const dispatch = useDispatch();
    MarketModel.update((data) => {
        dispatch({type: 'update', payload: data})
    });

    const markets = MarketModel.getData();

    return (
      <ScrollView style={styles.marketList}>
        { 
            !!markets.length && markets.map((market) => (
                <Market key={market.id} market={market}></Market>
            ))
        }
        { 
            !markets.length && (
                <Text style={styles.nodata}>Нет данных по выбранному региону</Text>
            )
        }
      </ScrollView>
    );
  }

const styles = StyleSheet.create({
    marketList: {
      margin: 5,
      marginBottom: 75
    },
    nodata: {
      fontSize: 20,
      color: 'white'
    }
})
